//Generated File 
export default class GUI2Operations{
	static readonly CHECK_FOR_PENDING_GUI_ACTION_RESULT = `checkForPendingGUIActionResult`;
	static readonly GET_ALL_PENDING_GUI_ACTION_RESULTS = `getAllPendingGUIActionResults`;
	static readonly OP_APPLY_WIZARD = `apply`;
	static readonly OP_APPROVE = `approve`;
	static readonly OP_AddDiscussion = `addDiscussion`;
	static readonly OP_AllSimpleEntitiesMatchingRef = `allSimpleEntitiesMatchingRef`;
	static readonly OP_BULK_DELETE = `bulkDelete`;
	static readonly OP_BULK_REVISE = `bulkRevise`;
	static readonly OP_CalcGuiActionDefaults = `calcGuiActionDefaults`;
	static readonly OP_CalculateDimensions = `calculateDimensions`;
	static readonly OP_Change_Capabilities = `changeCapabilities`;
	static readonly OP_Change_Password = `changePassword`;
	static readonly OP_DELETE = `delete`;
	static readonly OP_DUPLICATE = `duplicate`;
	static readonly OP_ExeTimedQuery = `exeTimedQuery`;
	static readonly OP_ExportToExcel = `exportToExcel`;
	static readonly OP_FETCH_CHAT_HISTORY = `fetchSessionMessagesHistory`;
	static readonly OP_FETCH_CHAT_SESSIONS = `fetchUserLatestChatSessions`;
	static readonly OP_FETCH_DEFINED_CHAT_MODELS = `fetchDefinedChatModels`;
	static readonly OP_FETCH_DISTINCT_COLUMN_VALUES_FOR_FILTERING = `fetchDistinctColumnValuesForFiltering`;
	static readonly OP_FETCH_ENUM_ALLOWED_VALUES = `fetchEnumAllowedValues`;
	static readonly OP_FETCH_GENERAL_ANNOUNCEMENTS = `fetchGeneralAnnouncements`;
	static readonly OP_FETCH_QUICK_FILTER_VALUES = `fetchQuickFilterValues`;
	static readonly OP_FIND_BY_BUSINESS_CODE = `findByBusinessCode`;
	static readonly OP_FIND_BY_ID = `findById`;
	static readonly OP_FIND_REFS_BY_IDS = `findRefsByIds`;
	static readonly OP_FIND_REF_BY_CODE = `findRefByCode`;
	static readonly OP_FIND_REF_BY_ID = `findRefById`;
	static readonly OP_FetchAutoDashboardsAndReports = `fetchAutoDashboardsAndReports`;
	static readonly OP_FetchChartsMetaData = `fetchChartsMetaData`;
	static readonly OP_FetchConfigEntriesScreens = `fetchConfigEntriesScreens`;
	static readonly OP_FetchDashBoardCharts = `fetchCharts`;
	static readonly OP_FetchDashboardGroupItems = `fetchDashboardGroupItems`;
	static readonly OP_FetchReportTaskResult = `fetchReportTaskResult`;
	static readonly OP_FetchSingleConfigEntryScreen = `fetchSingleConfigEntryScreen`;
	static readonly OP_FetchSingleDocumentTermScreen = `fetchSingleDocumentTermScreen`;
	static readonly OP_FetchTermConfigScreens = `fetchTermConfigScreens`;
	static readonly OP_FindOrCreateMyTheme = `findOrCreateMyTheme`;
	static readonly OP_Find_Approval_Case_By_Id = `findApprovalCaseById`;
	static readonly OP_Forgot = `forgot`;
	static readonly OP_KillReport = `killReport`;
	static readonly OP_KillTaskById = `killTaskById`;
	static readonly OP_LIST_REFERENCES = `listReferences`;
	static readonly OP_LIST__TOP_APPROVALS_AND_COUNT = `listTopApprovalsAndCount`;
	static readonly OP_LIST__TOP_NOTIFICATIONS_AND_COUNT = `listTopNotificationsAndCount`;
	static readonly OP_ListForSearchView = `listForSearchView`;
	static readonly OP_List_Page_matching = `listPageMatching`;
	static readonly OP_Login = `login`;
	static readonly OP_Logout = `logout`;
	static readonly OP_NAVIGATE = `navigate`;
	static readonly OP_NEW = `new`;
	static readonly OP_NEW_IDS = `newIds`;
	static readonly OP_NewUUID = `newuuid`;
	static readonly OP_OnReportQuestionsChanged = `OnReportQuestionsChanged`;
	static readonly OP_PERFORM_GUI_Action = `performGuiAction`;
	static readonly OP_PERFORM_Grid_ACTIONS = `performGridAction`;
	static readonly OP_PERFORM_POST_ACTIONS = `performPostAction`;
	static readonly OP_PERFORM_Prevalidation = `prevalidate`;
	static readonly OP_PerformCustomPostAction = `performCustomPostAction`;
	static readonly OP_REVISE = `revise`;
	static readonly OP_ReLogin = `reLogin`;
	static readonly OP_ReportMetadata = `reportMetadata`;
	static readonly OP_ResendOtpMsg = `resendOtpMsg`;
	static readonly OP_ResetPasswordByToken = `resetPasswordByToken`;
	static readonly OP_RunReport = `runReport`;
	static readonly OP_RunTooltip = `runTooltip`;
	static readonly OP_Run_Custom_Action = `runCustomAction`;
	static readonly OP_SAVE_AND_COMMIT = `saveAndCommit`;
	static readonly OP_SAVE_DRAFT = `saveDraft`;
	static readonly OP_SAVE_WIZARD_DATA = `saveWizard`;
	static readonly OP_SEARCH = `search`;
	static readonly OP_SEARCH_ALL = `searchAll`;
	static readonly OP_SEARCH_FOR_SERIAL = `searchForSerial`;
	static readonly OP_SEND_AI_MSG = `aimsg`;
	static readonly OP_SEND_ENTITY_RECORD_TO_AI = `entityRecordToAI`;
	static readonly OP_SEND_REPORT_TO_AI = `aireport`;
	static readonly OP_SEND_USER_FEEDBACK_FOR_AI_ANSWER = `aiAnswerFeedback`;
	static readonly OP_Suggest = `suggest`;
	static readonly OP_TABULAR_LIST_PAGE = `tabularListPage`;
	static readonly OP_UPDATE_APPROVALS_AND_NOTIFICATIONS = `updateApprovalsAndNotifications`;
	static readonly OP_UPDATE_TAX_AUTHORITY_JSON = `updateTaxAuthJson`;
	static readonly OP_UPLOAD_AI_FILE = `aiUploadFile`;
	static readonly OP_WIZARD_METADATA = `metaData`;
	static readonly OP_WIZARD_NEXT_STEP = `onNextStep`;
	static readonly OP_bulkEditAndSave = `bulkEditAndSave`;
	static readonly OP_checkTerminalPayment = `checkTerminalPayment`;
	static readonly OP_completeTerminalPayment = `completeTerminalPayment`;
	static readonly OP_fetchAppsConfig = `fetchAppsConfig`;
	static readonly OP_fetchBulkEditFields = `fetchBulkEditFields`;
	static readonly OP_fetchDimsConfig = `fetchDimsConfig`;
	static readonly OP_fetchTableAndColumnNames = `fetchTableAndColumnNames`;
	static readonly OP_isPrintReportPossible = `isPrintReportPossible`;
	static readonly OP_listTopNotificationsAndApprovals = `topNotificationsAndApprovals`;
	static readonly OP_markAsReadTop5Notifications = `markAsReadTop5Notifications`;
	static readonly OP_preparePGWLine = `preparePGWLine`;
	static readonly OP_processImportData = `processImportData`;
	static readonly OP_runSQL = `runSQL`;
	static readonly OP_searchForFieldsHelpMsgs = `searchForFieldsHelpMsgs`;
	static readonly OP_searchForHelpMsgs = `searchForHelpMsgs`;
	static readonly OP_sendEmailWithResult = `sendEmailWithResult`;
	static readonly OP_signDocuments = `signDocuments`;
	static readonly OP_startTerminalPayment = `startTerminalPayment`;
	static readonly OP_uploadFileByDataURL = `uploadFileByDataURL`;
}
